module.exports = __webpack_public_path__ + "img/holidays.55908f0c.png";